<template>
	<b-pagination
		v-model="page"
		v-if="total > itemsPerPage"
		:total-rows="total"
		:per-page="itemsPerPage"
		class="mt-4"
		@input="$emit('input', $event)"
	/>
</template>

<script>
export default {

	props: {
		value: {
			type: Number,
			required: true,
		},
		itemsPerPage: {
			type: Number,
			required: true,
		},
		total: {
			type: Number,
			required: true,
		},
	},

	data ()
	{
		return {
			page: this.value,
		};
	},
}
</script>